export default __webpack_public_path__ + "static/media/DailyRoutine_00.254e554b.png";